import { render, staticRenderFns } from "./PDCRequest.vue?vue&type=template&id=036fb28e&"
import script from "./PDCRequest.vue?vue&type=script&lang=js&"
export * from "./PDCRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports